var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "redo_icon",
    d: "M2.027 18.6v-.116A13.043 13.043 0 0114.465 9.3V5.592a.593.593 0 011.013-.419l6.178 6.108a1.164 1.164 0 010 1.652l-6.178 6.108a.593.593 0 01-1-.407V14.9h-1.165A13.055 13.055 0 003.6 19.333a.9.9 0 01-.721.407.884.884 0 01-.879-.872.686.686 0 01.027-.268z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 15050",
    fill: "none",
    d: "M0 0h24v24H0z"
  })));
}
export default SvgRedoIcon;